<template>
  <div>
    <div style="background-color: #F9B006; height: 0.6rem">
      <div class="header">
        <a href="javascript:void(0)" @click="manager('/')">
          <img src="@/assets/mba001.png" alt="博雅爱文MBA联考之家" style="height: 0.6rem;width: 7rem;" />
        </a>
      </div>
      <div style="float: right;margin-right: 0.2rem;">
        <a
          href="javascript:void(0)"
          style="height: 0.6rem;color: #000;font-weight: 700;display: inline-block;line-height: 0.6rem;padding-right: 0.2rem;font-size: 20px;"
          @click="manager('/register')"
        >
          注册
        </a>
        <a
          href="javascript:void(0)"
          style="height: 0.6rem;color: #000;font-weight: 700;display: inline-block;line-height: 0.6rem;padding-right: 0.2rem;font-size: 20px;"
          @click="manager('/login')"
        >
          登录
        </a>
        <a
          href="javascript:void(0)"
          style="height: 0.6rem;color: #000;font-weight: 700;display: inline-block;line-height: 0.6rem;font-size: 20px;"
          @click="manager('/user')"
        >
          用户中心
        </a>
      </div>
    </div>
    <div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#1E23F4"
        text-color="#fff"
        active-text-color="#CD0000"
      >
        <el-menu-item index="0" class="menu-img">
          <div>
            <a href="javascript:void(0)" @click="manager('/user')">
              <img src="@/assets/logo.gif" alt="联考之家" class="menu-img-size" />
            </a>
          </div>
        </el-menu-item>
        <el-menu-item index="1">
          <a href="javascript:void(0)" @click="manager('/')">
            <div class="menu-padding">首页</div>
          </a>
        </el-menu-item>
        <el-menu-item index="2">
          <a href="javascript:void(0)" @click="manager('/collegelibrary')">
            <div class="menu-padding">院校库</div>
          </a>
        </el-menu-item>
        <el-menu-item index="3">
          <a href="javascript:void(0)" @click="manager('/information')">
            <div class="menu-padding">资讯</div>
          </a>
        </el-menu-item>
        <el-menu-item index="4">
          <a href="javascript:void(0)" @click="manager('/sign')">
            <div class="menu-padding">报名流程</div>
          </a>
        </el-menu-item>
        <el-menu-item index="5">
          <a href="javascript:void(0)" @click="manager('/lines')">
            <div class="menu-padding">国家线</div>
          </a>
        </el-menu-item>
        <el-menu-item index="6">
          <a href="javascript:void(0)" @click="manager('/department')">
            <div class="menu-padding">商科教育专委会</div>
          </a>
        </el-menu-item>
        <el-menu-item index="7">
          <a href="javascript:void(0)" @click="manager('/datadownload')">
            <div class="menu-padding">备考资料</div>
          </a>
        </el-menu-item>
        <el-menu-item index="8">
          <a href="javascript:void(0)" @click="manager('/recruit')">
            <div class="menu-padding">职业招聘</div>
          </a>
        </el-menu-item>
        <el-menu-item index="9">
          <a href="javascript:void(0)" @click="manager('/train')">
            <div class="menu-padding">培训调剂</div>
          </a>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- Home 和 User 的路由占位符 -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div style="background-color: rgb(58, 58, 58);border: 1px solid rgb(58, 58, 58);margin: 0;">
      <div class="footer">
        <el-row :gutter="0" style="width: 7rem;text-align: center;">
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/')" title="网站首页">网站首页</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="关于我们">关于我们</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="服务条款">服务条款</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="广告服务">广告服务</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="联系我们">联系我们</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="网站地图">网站地图</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="版权声明">版权声明</a>
          </el-col>
          <el-col :span="3">
            <a href="javascript:void(0)" @click="managerBlank('/contact')" title="帮助中心">帮助中心</a>
          </el-col>
        </el-row>
      </div>
      <div class="footer2">
        版权所有：博雅爱文MBA联考之家
        <br />
        总部地址：北京市海淀区中关村科贸大厦1810
        <br />
        <div style="display: flex;justify-content: center">
          <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" class="ga-icon" />
          <a href="https://beian.miit.gov.cn" target="_blank">
            <span style="vertical-align: middle;font-size: 0.13rem;color: #fff;">京ICP备17008003号-2</span>
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <span style="vertical-align: middle;font-size: 0.13rem;color: #fff;">京ICP备17058207号-1</span>
          </a>
        </div>
        合作电话：11111111111
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Main',
  data() {
    return {
      activeIndex: '1'
    }
  },
  created () {
  },
  computed: {
    // 从 vuex 中把指定名称的 State 数据映射到组件中使用
    ...mapState(['tokenCustomer', 'userCustomer'])
  },
  watch: {
    $route: function () {
      if (this.$route.fullPath === '/') {
        this.activeIndex = '1'
      }
      if (this.$route.fullPath === '/collegelibrary') {
        this.activeIndex = '2'
      }
      if (this.$route.fullPath === '/information') {
        this.activeIndex = '3'
      }
      if (this.$route.fullPath === '/sign') {
        this.activeIndex = '4'
      }
      if (this.$route.fullPath === '/lines') {
        this.activeIndex = '5'
      }
      if (this.$route.fullPath === '/datadownload') {
        this.activeIndex = '6'
      }
      if (this.$route.fullPath === '/recruit') {
        this.activeIndex = '7'
      }
      if (this.$route.fullPath === '/train') {
        this.activeIndex = '8'
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    },
    manager (address) {
      this.$router.push({ path: address })
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
  font-size: 0.14rem;
}
.header {
  float: left !important;
  height: 0.6rem;
  width: 7rem;
}
.header-message-tag {
  display: inline-block;
  width: 1.5rem;
  height: 0.6rem;
  line-height: 0.6rem;
  vertical-align: middle;
  text-align: center;
  font-size: 0.14rem;
}
.menu-img {
  line-height: 0 !important;
}
.menu-img-size {
  width: 1rem;
  height: 0.5rem;
}
.menu-padding {
  display: block;
  height: 0.5rem;
  padding-right: 0.15rem;
  padding-left: 0.15rem;
}
.footer {
  margin: 0 auto;
  margin-top: 0.2rem;
  margin-bottom: 0.1rem;
  width: 7rem;
}
.footer a {
  font-size: 0.13rem;
  color: #fff;
}
.footer2 {
  text-align: center;
  line-height: 26px;
  font-size: 0.13rem;
  color: #fff;
  margin-bottom: 0.1rem;
}
.ga-icon {
  margin-right: 0.05rem;
  padding-top: 0.02rem;
  height: 0.15rem;
  width: 0.15rem;
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
/deep/ .el-menu-item {
  padding: 0;
}
/deep/ .el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
}
/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}
/deep/ .el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>
